<template>
  <div v-if="isVisible" class="slot-banner">
    <slot></slot>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import moment from 'moment';

const MAX_TIMEOUT_DELAY = 2147483647;

export default defineComponent({
  name: 'SlotBanner',
  inject: ['root'],
  emits: ['start', 'finish'],
  props: {
    start: {
      type: String,
      validator: (value) => {
        return moment(value, moment.ISO_8601).isValid();
      },
    },
    finish: {
      type: String,
      validator: (value) => {
        return moment(value, moment.ISO_8601).isValid();
      },
    },
  },
  data() {
    return {
      isVisible: false,
    };
  },
  created() {
    this.initData();
  },
  mounted() {
    this.activate();
  },
  methods: {
    initData() {
      this.dates = {
        now: new Date(),
        start: this.start ? new Date(this.start) : null,
        finish: this.finish ? new Date(this.finish) : null,
      };

      if (this.dates.start && this.dates.finish && this.dates.start >= this.dates.finish) {
        throw new Error('The start date cannot be greater than the finish date!');
      }

      this.timeouts = {
        show: null,
        hide: null,
      };
    },
    async activate() {
      if (this.isLate() && this.dates.finish) {
        this.$emit('finish');
        return;
      }

      if (this.isEarly() && this.dates.start) {
        await this.scheduleShowing();
      } else {
        this.show();
      }

      this.$emit('start');

      if (this.dates.finish) {
        await this.scheduleHiding();
        this.$emit('finish');
      }
    },

    show() {
      if (this.timeouts.show) {
        clearTimeout(this.timeouts.show);
        this.timeouts.show = null;
      }

      this.isVisible = true;
    },
    scheduleShowing() {
      return new Promise(resolve => {
        const ms = this.dates.start - Date.now();

        if (ms < 0 || ms >= MAX_TIMEOUT_DELAY) resolve();

        this.timeouts.show = setTimeout(() => {
          this.show();
          resolve();
        }, ms);
      });
    },
    hide() {
      if (this.timeouts.hide) {
        clearTimeout(this.timeouts.hide);
        this.timeouts.hide = null;
      }

      this.isVisible = false;
    },
    scheduleHiding() {
      return new Promise(resolve => {
        const ms = this.dates.finish - Date.now();

        if (ms >= MAX_TIMEOUT_DELAY) return;

        if (ms < 0) resolve();

        this.timeouts.hide = setTimeout(() => {
          this.hide();
          resolve();
        }, ms);
      });
    },

    isEarly() {
      return this.dates.now < this.dates.start;
    },
    isLate() {
      return this.dates.now > this.dates.finish;
    },
  },
});
</script>

<style lang="scss">
.slot-banner {
  width: 100%;
  height: 86px;
  position: sticky;
  top: 0;
  z-index: 9999;

  background-color: #02367a;
}

@media print {

  .slot-banner {
    display: none;
  }

}
</style>
